export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			value: '',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Estado de pedido ML',
	plural_model_name_spanish: 'Estados de pedido ML',
	create_model_name_spanish: 'Nuevo',
	text_delete: 'el',
}
